module.exports = __webpack_public_path__ + "static/media/algo-pasa-pero-no-se-que.de0057a0.png";